import { Formik, Form, ErrorMessage } from "formik";

const FormBody = (props) => {
	const {
		initialValues,
		validationSchema,
		onSubmit,
		children,
		className,
		enableReinitialize = false,
	} = props;
	return (
		<Formik
			className={className}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			enableReinitialize={enableReinitialize}
		>
			<Form>{children}</Form>
		</Formik>
	);
};

export const LevelReq = (props) => {
	return (
		<label {...props}>
			{props.children}
			<span className="text-danger">*</span>
		</label>
	);
};

// export const FormBtn = ({isLoading}) => {
// 	return (isLoading? )
// }

export const formatFieldError = (message) => {
	if (typeof message !== "string" || !message.trim()) return null;
	return message;
};

export const InputError = (props) => {
	return (
		<ErrorMessage
			name={props.name}
			render={(msg) => {
				const text = formatFieldError(msg);
				if (!text) return null;
				return <small className="text-danger fs-7">{text}</small>;
			}}
		/>
	);
};

export const InlineFieldError = ({ message }) => {
	const text = formatFieldError(message);
	if (!text) return null;
	return <small className="text-danger fs-7 d-block mt-1">{text}</small>;
};

export default FormBody;
